import "./index.css";
import App from "./App";
import AnalyticsProvider from "./providers/AnalyticsProvider";

const FinalChatBotView = () => {
  return <App />;
};
export default FinalChatBotView;
